export default "__VITE_ASSET__DM9NkUrN__"